{
  "kind": {
    "guest": "ลูกค้าทั่วไป (ไม่มีบัญชี)",
    "registered": "มีบัญชี"
  },
  "columns": {
    "name": "ชื่อ",
    "email": "อีเมล",
    "phone": "เบอร์โทร",
    "kind": "บัญชี",
    "locale": "ภาษา",
    "tags": "แท็ก",
    "marketing": "รับข่าวทางอีเมล",
    "last_seen": "ใช้ล่าสุด",
    "created": "ตั้งแต่",
    "state": "สถานะ"
  },
  "locales": {
    "en": "English",
    "ja": "日本語",
    "th": "ไทย",
    "zh_Hant": "繁體中文",
    "zh_Hans": "简体中文"
  },
  "marketing": {
    "yes": "ใช่",
    "no": "ไม่"
  },
  "state": {
    "merged": "รวมเข้าบัญชีอื่นแล้ว",
    "closed": "ปิดแล้ว",
    "open": "ใช้งาน"
  },
  "filters": {
    "q": "ค้นหา",
    "q_placeholder": "ชื่อ คานะ หรืออีเมล",
    "closed": "แสดงบัญชีที่ปิด/รวมแล้วด้วย"
  },
  "list": {
    "intro": "ทุกคนที่เคยซื้อ ทั้งมีบัญชีและไม่มีบัญชี กดที่แถวเพื่อดูออเดอร์ เครดิตร้าน และรวมบัญชีซ้ำ",
    "intro_limited": "ตำแหน่งของคุณเห็นเฉพาะชื่อลูกค้าและเบอร์โทร 4 ตัวท้าย"
  },
  "detail": {
    "back": "ลูกค้าทั้งหมด",
    "load_failed": "เปิดข้อมูลลูกค้าไม่ได้",
    "orders": "ออเดอร์ (เว็บและหน้าร้าน)",
    "no_orders": "ยังไม่มีออเดอร์ของอีเมลนี้",
    "orders_hint": "ค้นหาออเดอร์จากอีเมลของลูกค้า",
    "consents": "ความยินยอม (ความเป็นส่วนตัว)",
    "no_consents": "ยังไม่มีบันทึกความยินยอม",
    "merged_into": "เปิดบัญชีที่รวมเข้าไป",
    "limited": "ตำแหน่งของคุณเห็นเฉพาะชื่อและเบอร์โทร 4 ตัวท้าย ถ้าต้องการมากกว่านี้ให้ถามผู้จัดการ",
    "profile": "รายละเอียด",
    "email_verified": "ยืนยันอีเมลแล้ว",
    "profile_hint": "ลูกค้าแก้ข้อมูลเหล่านี้เองที่เว็บ (บัญชีของฉัน)"
  },
  "consent": {
    "privacy": "นโยบายความเป็นส่วนตัว",
    "terms": "เงื่อนไขการขาย",
    "marketing": "รับข่าวทางอีเมล",
    "cross_border": "เก็บข้อมูลในต่างประเทศ",
    "accepted": "ยินยอม",
    "declined": "ไม่ยินยอม"
  },
  "credit": {
    "title": "เครดิตร้าน",
    "issue": "ให้เครดิต",
    "issue_title": "ให้เครดิตร้าน",
    "issue_description": "ลูกค้าใช้จ่ายได้ทั้งที่ร้านและบนเว็บ จนถึงวันสุดท้าย",
    "issue_confirm": "ให้เครดิต",
    "issued": "ให้เครดิตร้าน {{amount}} แล้ว",
    "issued_hint": "ใช้ได้ถึง {{day}}",
    "amount": "ยอด",
    "reason": "เหตุผล",
    "reason_placeholder": "เช่น ขอโทษที่ส่งของช้า",
    "kind": "ลูกค้าจ่ายเงินแลกมาไหม?",
    "paid_for": "ใช่ — แทนเงิน (คืนเงิน, รับซื้อการ์ด)",
    "free": "ไม่ — ของขวัญจากร้าน",
    "last_day": "วันสุดท้าย",
    "last_day_hint": "นานสุดถึง {{day}}: ถ้านานกว่านี้จะเข้ากฎหมาย 資金決済法",
    "blocker": {
      "amount": "ใส่ยอดเป็นเยนเต็มจำนวน",
      "reason": "เขียนเหตุผล",
      "day_after_max": "เครดิตร้านใช้ได้นานสุด 6 เดือน — เลือก {{day}} หรือก่อนหน้า (資金決済法)",
      "day_past": "วันสุดท้ายเป็นวันที่ผ่านไปแล้วไม่ได้",
      "day_invalid": "เลือกวัน"
    },
    "load_failed": "โหลดเครดิตร้านไม่ได้",
    "paid_for_balance": "จ่ายแลกมา:",
    "free_balance": "ของขวัญ:",
    "next_expiry": "หมดอายุถัดไป:",
    "lots": "เครดิตที่ให้",
    "col": {
      "given": "วันที่ให้",
      "amount": "ยอด",
      "left": "คงเหลือ",
      "last_day": "วันสุดท้าย",
      "reason": "เหตุผล"
    },
    "expired": "หมดอายุ",
    "paid_for_short": "จ่ายแลกมา",
    "free_short": "ของขวัญ",
    "none": "ยังไม่มีเครดิตร้าน",
    "history": "ประวัติ",
    "entry": {
      "issue": "ให้",
      "redeem": "ใช้",
      "expire": "หมดอายุ",
      "refund_in": "ได้คืนจากการคืนเงิน",
      "adjust": "แก้ไข",
      "reverse": "ดึงคืน"
    },
    "law": "เครดิตร้านใช้ได้นานสุด 6 เดือน (資金決済法) และแลกเป็นเงินสดไม่ได้"
  },
  "merge": {
    "open": "รวมบัญชีซ้ำ",
    "title": "รวม 2 บัญชีของคนเดียวกัน",
    "description": "หาบัญชีอีกอัน เลือกบัญชีที่จะเก็บไว้ ดูผลที่จะเกิด แล้วยืนยัน",
    "search": "หาบัญชีอีกอัน",
    "search_hint": "ชื่อหรืออีเมล",
    "which": "บัญชีไหนเป็นคนเดียวกัน?",
    "none": "ไม่พบบัญชีอื่น",
    "choose": "เลือกบัญชีอีกอันก่อน",
    "stays": "เก็บบัญชีไหนไว้?",
    "keep": "เก็บไว้",
    "close": "ปิด",
    "next": "ตรวจแล้วรวม",
    "effect_addresses": "ที่อยู่และการเข้าสู่ระบบย้ายไปที่ {{name}}",
    "effect_closed": "{{email}} จะถูกปิด",
    "effect_search": "ค้นหา {{email}} ภายหลังจะเจอ {{name}}",
    "effect_orders": "ออเดอร์ยังเก็บข้อมูลลูกค้าเดิม",
    "confirm_title": "รวมบัญชีเหล่านี้?",
    "confirm_consequence": "{{close}} จะถูกปิดและข้อมูลย้ายไปที่ {{keep}} ย้อนกลับไม่ได้",
    "confirm": "รวม",
    "done": "รวมแล้ว — เก็บ {{name}} ไว้",
    "done_hint": "ย้ายที่อยู่ {{addresses}} รายการ"
  },
  "dsar": {
    "title": "ข้อมูลของลูกค้า (กฎหมายคุ้มครองข้อมูล)",
    "body": "เมื่อลูกค้าขอสำเนาข้อมูลหรือขอให้ลบข้อมูล ให้บันทึกคำขอที่นี่ ระบบจะรวบรวมจากทุกส่วนของร้าน",
    "export": "สำเนาข้อมูล",
    "delete": "ลบข้อมูล",
    "export_title": "ทำสำเนาข้อมูลของลูกค้าคนนี้?",
    "export_consequence": "ลูกค้าจะได้ลิงก์ดาวน์โหลดทางอีเมล เขียนว่าคุณยืนยันตัวตนอย่างไร",
    "delete_title": "ลบข้อมูลของลูกค้าคนนี้?",
    "delete_consequence": "ข้อมูลที่กฎหมายให้ร้านเก็บ (ใบเสร็จ, 古物台帳) จะยังอยู่ เขียนว่าคุณยืนยันตัวตนอย่างไร",
    "done_export": "ขอสำเนาข้อมูลแล้ว",
    "done_delete": "ขอลบข้อมูลแล้ว",
    "done_hint": "จะเสร็จภายในเวลาที่กฎหมายกำหนด และมีแจ้งเตือน"
  }
}
